export default "__VITE_ASSET__P_1GxNrc__"